const $inject = [
  '$filter',
  'moment',
  'flightFilterPackageService',
  'flightFilterUnPackageService',
  'settingsService',
  'travelService',
  'ENUMS',
  'dateTimeService',
];

// We need to share same instance of the array between the filters in the modal and the ones in the page
var timeSegmentCountsSingleton = (function () {
  var segmentCounts = [];

  return {
    getSegmentCounts: function () {
      return segmentCounts;
    },
  };
})();

const flightFilterService = function flightFilterService(
  $filter,
  moment,
  pkgService,
  unPkgService,
  settingsService,
  travelService,
  ENUMS,
  dateTimeService
) {
  const TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
  let showPanel = false;
  const service = {
    filters: new Filters(),
    getFilters: () => service.filters,
    isPanelOpen: () => showPanel,
    setMode: setMode,
    openPanel: openPanel,
    closePanel: closePanel,
    deleteOptions: deleteOptions,
    process: process,
    sortProcess: sortProcess,
    clear: clear,
    filterCheapestFares: filterCheapestFares,
    cheapestFareFilterActive: false,
    filtersApplied: 0,
    mode: 'unPackage',
    shouldCleanOptions: false,
    defaultFareIndex: 0,
  };

  function setMode(mode) {
    service.mode = mode;
    service.deleteOptions();
    clearSelected();
    service.process();
  }

  function Filters() {
    let self = this;

    this.stops = {
      label: 'Stops',
      id: 'stops',
      isResultsFilter: true,
      open: true,
      type: 'checkboxGroup',
      reference: 'Stops',
      options: [],
      selected: [],
      unPkgCount: unPkgService.countStops,
      unPkgFilter: unPkgService.filterSegmentOptions,
      pkgCount: pkgService.countStops,
      pkgFilter: pkgService.filterSegmentOptions,
      clear: clearOptions,
    };

    this.carrier = {
      label: 'Airlines',
      id: 'carrier',
      includeExcludeSelections: [],
      isResultsFilter: true,
      open: true,
      type: 'checkboxGroup',
      maxOptions: 8,
      maxOptionsCur: 8,
      reference: 'Carrier',
      options: [],
      unPkgCount: unPkgService.countCarrier,
      unPkgFilter: unPkgService.filterSegmentOptions,
      pkgCount: pkgService.countCarrier,
      pkgFilter: pkgService.filterSegmentOptions,
      clear: clearOptions,
    };
    this.flightTime = {
      label: 'Times',
      id: 'times',
      isResultsFilter: true,
      open: true,
      type: 'departArrivalTime',
      defaultMax: 1439,
      defaultMin: 0,
      options: [],
      rzslider: [],
      rzsliderCallbacks: {
        translate: translateMinutesTime,
        onChange: function () {
          process(self.flightTime);
        },
      },
      segmentCounts: timeSegmentCountsSingleton.getSegmentCounts(),
      unPkgCount: unPkgService.countTime,
      pkgCount: pkgService.countTime,
      unPkgFilter: unPkgService.filterFlightTime,
      pkgFilter: pkgService.filterFlightTime,
      isActive: function () {
        return this.min > this.defaultMin || this.max < this.defaultMax;
      },
      clear: function () {
        this.options.forEach((o) => {
          o.minArrive = o.defaultMinArrive;
          o.maxArrive = o.defaultMaxArrive;
          o.minDepart = o.defaultMinDepart;
          o.maxDepart = o.defaultMaxDepart;
        });
      },
    };

    this.priceRange = {
      label: 'Price',
      id: 'price',
      labelSuffix: `(${settingsService.settings.Currency.Code})`,
      isResultsFilter: true,
      itemType: 'fares',
      open: true,
      type: 'range',
      reference: 'Price',
      options: [],
      rzslider: [],
      segmentCounts: [],
      rzsliderCallbacks: {
        translate: (value) => $filter('currency')(value, '', 0),
        onChange: function () {
          process(self);
        },
      },
      unPkgFilter: unPkgService.filterPrice,
      unPkgCount: unPkgService.countPrice,
      pkgFilter: pkgService.filterPrice,
      pkgCount: pkgService.countPrice,
      isActive: function () {
        return this.min > this.defaultMin || this.max < this.defaultMax;
      },
      clear: function () {
        this.options.forEach((o) => {
          o.min = o.defaultMin;
          o.max = o.defaultMax;
        });
      },
    };

    this.cabin = {
      label: 'Cabin class',
      id: 'cabin',
      isResultsFilter: true,
      open: false,
      type: 'checkboxGroup',
      reference: 'Carrier',
      selectedReference: 'value',
      options: [],
      unPkgCount: unPkgService.countCabin,
      unPkgFilter: unPkgService.filterFareOptions,
      pkgCount: pkgService.countCabin,
      pkgFilter: pkgService.filterFareOptions,
      clear: clearOptions,
    };

    this.airports = {
      label: 'Connecting airports',
      includeExcludeSelections: [],
      id: 'airport',
      isResultsFilter: true,
      open: true,
      type: 'checkboxGroup',
      maxOptions: 8,
      maxOptionsCur: 8,
      options: [],
      selected: [],
      unPkgCount: unPkgService.countAirports,
      unPkgFilter: unPkgService.filterSegmentOptions,
      pkgCount: pkgService.countAirports,
      pkgFilter: pkgService.filterSegmentOptions,
      clear: clearOptions,
    };

    this.layover = {
      label: 'Layover duration',
      id: 'layover',
      isResultsFilter: true,
      itemType: 'flights',
      open: false,
      type: 'range',
      reference: 'CarbonEmission',
      options: [],
      rzsliderCallbacks: {
        translate: (mins, sliderId, label) => {
          if (!self.layover.options.length) return;
          if (isNaN(mins) || mins === Infinity || mins === -Infinity) return self.layover.options[0].defaultMin + ' min';
          const days = Math.floor(mins / 1440);
          const hours = Math.floor((mins % 1440) / 60);
          const minutes = mins % 60;
          if (days === 0 && hours === 0) return `${minutes} min`;
          if (days === 0) return `${hours} hr ${minutes} min`;
          return `${days} d ${hours} hr ${minutes} min`;
        },
        onChange: function () {
          process(self.layover);
        },
      },
      rzslider: [],
      segmentCounts: [],
      unPkgCount: unPkgService.countLayoverOptions,
      pkgCount: pkgService.countLayoverOptions,
      unPkgFilter: unPkgService.filterLayover,
      pkgFilter: pkgService.filterLayover,
      clear: function () {
        this.options.forEach((o) => {
          o.min = 0;
          o.max = o.defaultMax;
        });
      },
    };

    this.policy = {
      label: 'Policy',
      id: 'policy',
      isResultsFilter: true,
      open: false,
      type: 'checkboxGroup',
      options: [],
      unPkgCount: unPkgService.countPolicy,
      unPkgFilter: unPkgService.filterFareOptions,
      pkgCount: pkgService.countPolicy,
      pkgFilter: pkgService.filterFareOptions,
      clear: clearOptions,
    };

    this.carbonFootprintRange = {
      label: 'Carbon footprint',
      id: 'carbonFootprint',
      itemType: 'fares',
      isResultsFilter: true,
      open: false,
      type: 'range',
      reference: 'CarbonEmission',
      unPkgFilter: unPkgService.filterCarbonFootprint,
      pkgCount: pkgService.countCarbonFootprint,
      unPkgCount: unPkgService.countCarbonFootprint,
      pkgFilter: pkgService.filterCarbonFootprint,
      segmentCounts: [],
      options: [],
      rzsliderCallbacks: {
        translate: (value) => $filter('currency')(value, '', 0),
        onChange: function () {
          process(self);
        },
      },
      rzslider: [],
      isActive: function () {
        return this.min > this.defaultMin || this.max < this.defaultMax;
      },

      clear: function () {
        this.options.forEach((o) => {
          o.min = o.defaultMin;
          o.max = o.defaultMax;
        });
      },
    };

    this.aircraft = {
      label: 'Aircraft Type',
      id: 'aircraft',
      includeExcludeSelections: [],
      isResultsFilter: true,
      open: false,
      type: 'checkboxGroup',
      maxOptions: 8,
      maxOptionsCur: 8,
      reference: 'Carrier',
      options: [],
      unPkgCount: unPkgService.countAircraft,
      unPkgFilter: unPkgService.filterSegmentOptions,
      pkgCount: pkgService.countAircraft,
      pkgFilter: pkgService.filterSegmentOptions,
      clear: clearOptions,
    };

    this.flexibility = {
      label: 'Flexibility',
      id: 'flexibility',
      isResultsFilter: true,
      open: false,
      type: 'checkboxGroup',
      options: [],
      unPkgCount: unPkgService.countFlexibility,
      unPkgFilter: unPkgService.filterFareOptions,
      pkgCount: pkgService.countFlexibility,
      pkgFilter: pkgService.filterFareOptions,
      clear: clearOptions,
    };

    this.safScore = {
      label: 'SAF Score',
      id: 'safScore',
      isResultsFilter: true,
      open: false,
      type: 'checkboxGroup',
      reference: 'SafScore',
      options: [],
      unPkgCount: unPkgService.countSAFScore,
      unPkgFilter: unPkgService.filterSegmentOptions,
      pkgCount: pkgService.countSAFScore,
      pkgFilter: pkgService.filterSegmentOptions,
      clear: clearOptions,
      hideIfNoOptions: true,
    };

    this.segment = {
      id: 'segment',
      pkgFilter: pkgService.filterPackageSegments,
      clear: function () {
        travelService.packageResults.forEach((pkg) => {
          pkg.Segments.forEach((segment) => (segment.selected = false));
        });
      },
    };

    this.cartItems = {
      unPkgFilter: unPkgService.filterCartItems,
    };

    this.displayFare = {
      unPkgFilter: unPkgService.filterDisplayFare,
    };
  }

  function process(activeFltr, opt) {
    service.filtersApplied = 0;
    const filters = service.filters;
    service.mode === 'package'
      ? pkgService.process(filters, activeFltr, opt, bumpFiltersApplied, getFiltersApplied, service.shouldCleanOptions)
      : unPkgService.process(filters, activeFltr, opt, bumpFiltersApplied, getFiltersApplied, service.shouldCleanOptions);
  }

  function sortProcess(data, segIdx) {
    service.mode === 'package' ? pkgService.sortProcess(data) : unPkgService.sortProcess(data, segIdx);
  }

  function clear() {
    Object.values(service.filters).forEach((flt) => {
      if (typeof flt.clear === 'function') flt.clear();
    });
    process();
  }

  function openPanel(index) {
    // If it's the first time opening the filter panel, the ALL tab options will be "cleaned" each time process() is called.
    // Checkboxes with count of 0 are removed.
    // It is done here because the process() methods are called multiple times and "cleaning" before all
    // of the process() methods are done will mess up the options/counts.
    // Setting shouldCleanOptions = true lets us know that all of the initial process() calls are complete.
    if (!service.shouldCleanOptions) {
      service.shouldCleanOptions = true;
      process();
    }

    showPanel = true;
    service.defaultFareIndex = index;
    document.body.classList.add('hideScrollbars');
  }

  function closePanel() {
    showPanel = false;
    document.body.classList.remove('hideScrollbars');
  }

  function translateMinutesTime(mins) {
    if (mins === 0) return '12:00 AM';
    let hours = Math.floor(mins / 60);
    let minutes = mins % 60;
    if (hours === 24 && minutes === 0) {
      hours = 23;
      minutes = 59;
    }
    if (minutes < 10) minutes = '0' + minutes;
    return moment(`${hours}:${minutes}`, 'H:mm').format(TIME_FORMAT);
  }

  function bumpFiltersApplied(filter, i) {
    if (i && i > 0) return;
    service.filtersApplied++;
  }

  function getFiltersApplied() {
    return service.filtersApplied;
  }

  function filterCheapestFares(segIdx) {
    clear();
    service.mode === 'package' ? pkgService.filterCheapestFares() : unPkgService.filterCheapestFares(segIdx);
  }

  function clearOptions() {
    this.options.forEach((opt) => opt.forEach((o) => (o.isActive = false)));
    this.selected = [];
  }

  function deleteOptions() {
    Object.values(service.filters).forEach((filter) => {
      if (filter.options) {
        filter.options = [];
      }
    });
  }

  function clearSelected() {
    travelService.results.forEach((result) => (result.selected = false));
    travelService.packageResults.forEach((result) => (result.selected = false));
  }

  return service;
};

flightFilterService.$inject = $inject;

export default flightFilterService;



// WEBPACK FOOTER //
// ./src/services/flightFilterService.js